angular.module('screenLoaderMod',[]);
